import { Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { OpenDialogYesOrNo } from "../app/landing/dialog-yes-or-no/dialog-yes-or-no.component";
// import 'rxjs/add/operator/map';
import { map, mergeMap } from 'rxjs/operators';

import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CryptoService } from './crypto.service';
import { TokenServiceService } from './token-service.service';
import { environment as ENV } from '../environments/environment';

// assign the already defined variable (in index.html) a type to silence type error.
// this is Angular dependent. As TypeScript is not as lenient as JavaScript.
// declare var digiCallback: any;
declare const qrcode: any;
declare var QrScanner : any;
// declare var $ : any;

@Component({
  selector: 'wl-laas',
  template: `
    <router-outlet></router-outlet>
    <wl-footer></wl-footer>
  `,
})
export class AppComponent implements OnInit, OnDestroy {

  private inactivityTimeoutId: any;
  private readonly INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes
  private activityEvents: string[] = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
  private boundOnActivity: any;
  private boundOnOtpVerified: any;
  private timersStarted: boolean = false;
  // private boundOnOtpVerified: any;
  // private timersStarted: boolean = false;

  // Session timer (absolute — no reset on activity)
  private sessionTimeoutId: any;
  private warningTimeoutId: any;
  private readonly SESSION_TIMEOUT = 30 * 60 * 1000; // 60 minutes
  private readonly WARNING_TIME = 25 * 60 * 1000; // 55 minutes (5 min before expiry)

  constructor(
    private dialog: MatDialog, private _elementRef: ElementRef,
    private cryptoService: CryptoService,
    private tokenService: TokenServiceService,
    private ngZone: NgZone) {
    this.boundOnActivity = this.onActivity.bind(this);
    this.boundOnOtpVerified = this.onOtpVerified.bind(this);
  }
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    var kccToken = this.tokenService.getKccToken();
    if (kccToken) {
      var url = ENV.mpWebHookUrl + '/webhook/endKccSession';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: kccToken }),
        keepalive: true
      });
      this.tokenService.clearKccToken();
    }
  }

  ngOnInit(): void {
    // Initialize ECDH E2E encryption session (only if enabled)
    if (ENV.enableEncryption) {
      this.cryptoService.initSession().then(function () {
        console.log('E2E encryption session ready');
      }).catch(function (err) {
        console.error('E2E encryption handshake failed — app will run without E2E encryption', err);
      });
    }

    // Listen for OTP verification success to start timers
    window.addEventListener('otpVerified', this.boundOnOtpVerified);
   

    
    // window.onload = () => {
    //   sessionStorage.clear();
    //   let windowsCount = sessionStorage.getItem('windows')
    //   console.log('------', sessionStorage.getItem("mpApplicantId"));
    //   console.log(windowsCount)
    //   if(parseInt(windowsCount) >= 1){ 
    //     this.dialog.open(OpenDialogYesOrNo, {
    //         width: "auto",
    //         height: "auto",
    //         data: {
    //           content1: "------",
    //           content2: "-------",
    //           button1Text: "OK",
    //         },
    //       });
         
    //     }else{ 
         
    //     sessionStorage.setItem("windows","1"); 
    //     } 
    // }

    // window.onbeforeunload = () => {
    //   sessionStorage.setItem("windows", "0");
    // }
  }

  ngOnDestroy(): void {
    this.stopInactivityWatcher();
    this.stopSessionTimer();
    window.removeEventListener('otpVerified', this.boundOnOtpVerified);
  }

  private onOtpVerified(): void {
    if (this.timersStarted) {
      return;
    }
    this.timersStarted = true;
    this.startInactivityWatcher();
    this.startSessionTimer();
    window.removeEventListener('otpVerified', this.boundOnOtpVerified);
  }

  // private onOtpVerified(): void {
  //   if (this.timersStarted) {
  //     return;
  //   }
  //   this.timersStarted = true;
  //   this.startInactivityWatcher();
  //   this.startSessionTimer();
  // }

  ngAfterViewInit(): void {
    // Delay the removal of Angular version for a brief moment to ensure the element is fully initialized
    setTimeout(() => {
      this._elementRef.nativeElement.removeAttribute('ng-version');
    }, 100);
  }

  private startInactivityWatcher(): void {
    this.resetInactivityTimer();
    var self = this;
    this.ngZone.runOutsideAngular(function () {
      self.activityEvents.forEach(function (event) {
        document.addEventListener(event, self.boundOnActivity, { passive: true });
      });
    });
  }

  private stopInactivityWatcher(): void {
    this.clearInactivityTimer();
    var self = this;
    this.activityEvents.forEach(function (event) {
      document.removeEventListener(event, self.boundOnActivity);
    });
  }

  private onActivity(event: Event): void {
    if (event && event.isTrusted) {
      this.resetInactivityTimer();
    }
  }

  private resetInactivityTimer(): void {
    this.clearInactivityTimer();
    var self = this;
    this.ngZone.runOutsideAngular(function () {
      self.inactivityTimeoutId = setTimeout(function () {
        self.ngZone.run(function () {
          self.handleInactivity();
        });
      }, self.INACTIVITY_TIMEOUT);
    });
  }

  private clearInactivityTimer(): void {
    if (this.inactivityTimeoutId) {
      clearTimeout(this.inactivityTimeoutId);
      this.inactivityTimeoutId = null;
    }
  }

  private handleInactivity(): void {
    console.log('User inactive for 15 minutes. Clearing session and redirecting to landing page.');
    this.stopInactivityWatcher();
    this.dialog.closeAll();
    var dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      disableClose: true,
      data: {
        content1: 'Your session has expired due to inactivity.',
        content2: 'The page will now refresh. Please start a new session.',
        button1Text: 'OK'
      }
    });
    dialogRef.afterClosed().subscribe(function () {
      sessionStorage.clear();
      window.location.href = '/';
    });
  }

  // ── Session Timer (absolute 60-min countdown, no reset) ──

  private startSessionTimer(): void {
    var self = this;
    this.ngZone.runOutsideAngular(function () {
      // Warning dialog at 55 minutes
      self.warningTimeoutId = setTimeout(function () {
        self.ngZone.run(function () {
          self.showSessionWarning();
        });
      }, self.WARNING_TIME);

      // Session expiry at 60 minutes
      self.sessionTimeoutId = setTimeout(function () {
        self.ngZone.run(function () {
          self.handleSessionExpiry();
        });
      }, self.SESSION_TIMEOUT);
    });
  }

  private stopSessionTimer(): void {
    if (this.warningTimeoutId) {
      clearTimeout(this.warningTimeoutId);
      this.warningTimeoutId = null;
    }
    if (this.sessionTimeoutId) {
      clearTimeout(this.sessionTimeoutId);
      this.sessionTimeoutId = null;
    }
  }

  private showSessionWarning(): void {
    this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      data: {
        content1: 'Your session will expire in 5 minutes.',
        content2: 'Please complete your journey before the session ends.',
        button1Text: 'OK'
      }
    });
  }

  private handleSessionExpiry(): void {
    console.log('Session expired after 60 minutes. Clearing session and redirecting to landing page.');
    this.dialog.closeAll();
    var dialogRef = this.dialog.open(OpenDialogYesOrNo, {
      width: 'auto',
      height: 'auto',
      disableClose: true,
      data: {
        content1: 'Your session has expired.',
        content2: 'The page will now refresh. Please start a new session.',
        button1Text: 'OK'
      }
    });
    dialogRef.afterClosed().subscribe(function () {
      sessionStorage.clear();
      sessionStorage.clear();
      window.location.href = '/';
    });
  }
}

